/**
 * Portal logger — now a thin re-export of the shared @owlcat/logger.
 *
 * The implementation was PROMOTED into packages/logger so the whole fleet emits
 * one structured JSON shape. This file is kept ONLY so portal's ~hundreds of
 * `@/shared/infrastructure/logging/logger` importers stay unchanged. Do not add
 * logic here — edit @owlcat/logger instead.
 */
export { logger } from '@owlcat/logger';
export type { Logger, LogContext, LogLevel } from '@owlcat/logger';
